import superagent from '@ott/superagent';

import getDefaultBrowserData from '../helpers/getDefaultBrowserData';
import * as T from '../types';

// todo: заменить входящие параметры на один параметр-объект с соответствующими ключами
export default function initPreAuth3DS(
  preAuthParams,
  shouldSkipAuth,
  customRoute,
  prepareBodyFunction,
  options = {}
) {
  return async (dispatch) => {
    const { timeout = 15000 } = options;

    if (shouldSkipAuth) {
      dispatch({
        type: T.GET_PRE_AUTH_SUCCESS,
        result: {
          authId: null,
          iframeUrl: null,
          isOld3DS: true,
          serverIframeUrl: null,
          threeDSMethodData: null,
        },
      });

      return;
    }

    dispatch({ type: T.GET_PRE_AUTH });

    let preparedPreAuthParams = { ...preAuthParams };

    preparedPreAuthParams.browserData = {
      ...preparedPreAuthParams.browserData,
      ...getDefaultBrowserData(),
    };

    // Если необходима специфичная для вертикали предварительная обработка параметров
    if (typeof prepareBodyFunction === 'function') {
      preparedPreAuthParams = prepareBodyFunction(preparedPreAuthParams);
    }

    try {
      const { body } = await superagent
        .post(customRoute || '/_pay-proxy/payment/pre-auth/')
        .send(preparedPreAuthParams)
        .timeout(timeout);

      const { error, result } = body;

      if (error || !result.success) {
        // Несмотря на неуспешность респонса, authId в нем все равно приходит и нам нужно его оттуда достать,
        // поэтому делаю кастомную ошибку и кладу туда authId
        const customError = new Error(body.message || 'Unsuccessful 3DS authorization');
        customError.authId = result?.authId;

        throw customError;
      }

      const {
        authId,
        orderId,
        paymentId,
        orderNumber,
        threeDSMethodNotificationURL,
        threeDSMethodURL,
        threeDSMethodURLServer,
        threeDSServerTransId,
        version,
      } = result;

      let serverIframeUrl = null;
      let iframeUrl = null;
      let dataJSON = null;

      if (threeDSMethodURLServer) {
        serverIframeUrl = threeDSMethodURLServer;
      }

      if (threeDSMethodURL && threeDSServerTransId && threeDSMethodNotificationURL) {
        iframeUrl = threeDSMethodURL;
        dataJSON = JSON.stringify({
          threeDSServerTransID: threeDSServerTransId,
          threeDSMethodNotificationURL,
        });
      } else if (threeDSMethodURLServer) {
        iframeUrl = threeDSMethodURLServer;
        serverIframeUrl = null;
        dataJSON = null;
      }

      dispatch({
        type: T.GET_PRE_AUTH_SUCCESS,
        result: {
          orderNumber,
          iframeUrl,
          serverIframeUrl,
          authId,
          orderId,
          paymentId,
          isOld3DS: version === '1.0',
          threeDSMethodData: dataJSON ? btoa(dataJSON) : null,
        },
      });
    } catch (error) {
      dispatch({
        type: T.GET_PRE_AUTH_FAIL,
        error,
      });
    }
  };
}
